/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import clsx from 'clsx';
import { MandatoryFeeTooltipIcon } from './MandatoryFeeTooltipIcon';

type MarginVariant = 'standalone' | 'withTotalPrice';

export const PointsMandatoryFeeSection: React.FC<{
  marginVariant: MarginVariant;
  mandatoryFeeDescription: string;
  isMarketingFee: boolean;
  staticContent: any;
  currentViewIsTab: boolean;
  isMapViewEnabled?: boolean;
  currentViewIsMobile?: boolean;
  fromHotelCard?: boolean;
  HQVRateBlockFlag?: boolean;
  pointsSaverFlag: any;
  toolTipList?: any;
  handleTooltipClick?: (e: React.MouseEvent | React.KeyboardEvent) => void;
  clickTrackingLoc: string;
  tooltipSubheading: string;
}> = ({
  marginVariant,
  mandatoryFeeDescription,
  isMarketingFee,
  staticContent,
  currentViewIsTab,
  isMapViewEnabled,
  currentViewIsMobile,
  fromHotelCard,
  HQVRateBlockFlag,
  pointsSaverFlag,
  toolTipList,
  handleTooltipClick,
  clickTrackingLoc,
  tooltipSubheading,
}) => {
  const getToolTipNotSaverMargin = (): string => {
    if (!toolTipList?.length || pointsSaverFlag || marginVariant === 'standalone') {
      return 'mt-n1';
    }
    return '';
  };

  const getMandatoryFeeMarginClass = (): string => {
    if (currentViewIsTab) {
      return marginVariant === 'standalone' ? 'mt-n1' : '';
    }

    if (isMapViewEnabled || currentViewIsMobile) {
      return '';
    }

    if (!HQVRateBlockFlag) {
      return getToolTipNotSaverMargin();
    }

    return '';
  };

  return (
    <div
      className={clsx(
        getMandatoryFeeMarginClass(),
        !HQVRateBlockFlag ? 'points-mandatory-fee-section' : 'points-mandatory-fee-section-hqv',
        pointsSaverFlag ? 'justify-content-start text-left' : '',
        !isMapViewEnabled && !pointsSaverFlag && (currentViewIsMobile || currentViewIsTab) ? 'text-left' : '',
        !isMapViewEnabled && !pointsSaverFlag && !currentViewIsTab && !currentViewIsMobile
          ? ''
          : pointsSaverFlag && isMapViewEnabled
          ? 'pb-1'
          : ''
      )}
      role="region"
      aria-label={mandatoryFeeDescription}
      tabIndex={0}
    >
      <span
        className={clsx(
          't-font-xs',
          !currentViewIsTab ? 'pt-1' : 'd-flex',
          pointsSaverFlag && isMapViewEnabled && !fromHotelCard
            ? ''
            : !isMapViewEnabled && !pointsSaverFlag && (currentViewIsMobile || currentViewIsTab)
            ? 'text-left'
            : 'text-right',
          currentViewIsTab && pointsSaverFlag
            ? `d-flex align-items-baseline ${HQVRateBlockFlag ? '' : 'justify-content-start'} `
            : '',
          currentViewIsTab && pointsSaverFlag ? (!isMapViewEnabled ? 'pb-0' : '') : ''
        )}
      >
        <span
          className={clsx(pointsSaverFlag ? 'points-mandatory-fee-text' : '', currentViewIsTab ? 'text-ellipsis' : '')}
        >
          {mandatoryFeeDescription}
          {(!currentViewIsTab && !isMapViewEnabled) || (currentViewIsTab && !pointsSaverFlag) || HQVRateBlockFlag
            ? ` ${!isMarketingFee ? staticContent?.feeLabel + ' ' : ''}`
            : ''}
        </span>
        <span className={clsx('nowrap-tooltip', currentViewIsTab ? 'pl-1' : '')}>
          {!currentViewIsTab && isMapViewEnabled && !HQVRateBlockFlag
            ? `${!isMarketingFee ? ' ' + staticContent?.feeLabel + ' ' : ''}`
            : ''}
          <MandatoryFeeTooltipIcon
            HQVRateBlockFlag={HQVRateBlockFlag}
            toolTipList={toolTipList}
            handleTooltipClick={handleTooltipClick}
            isMapViewEnabled={isMapViewEnabled}
            currentViewIsMobile={currentViewIsMobile}
            currentViewIsTab={currentViewIsTab}
            clickTrackingLoc={clickTrackingLoc}
            tooltipSubheading={tooltipSubheading}
          />
        </span>
      </span>
    </div>
  );
};
